import { Customer } from "../models/customer";

export const getFullNameCustomer = (customer?: Customer) => {
  if (customer) {
    if (customer?.fullName) return customer?.fullName;
    if (customer?.name && customer?.lastName) return `${customer?.name} ${customer?.lastName}`;
  }

  return "";
};
